import React from "react";

import { InputAdornment, MenuItem, Select, TextField } from "@mui/material";
import Grid from "@mui/material/GridLegacy";



type Props = {
  amount: string | number;
  currency: string;
  currencies: string[];
  onAmountChange: (v: string | number) => void;
  onCurrencyChange: (v: string) => void;
};

export default function RightInput({
  amount,
  currency,
  currencies,
  onAmountChange,
  onCurrencyChange,
}: Props) {

    
  return (
    <Grid item xs={12} md={5}>
      <TextField
        fullWidth
        label="მინდა ვიყიდო"
        value={amount}
        onChange={(e) => onAmountChange(e.target.value)}
        autoComplete="off"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Select
                value={currency}
                onChange={(e) => onCurrencyChange(e.target.value)}
                variant="standard"
                disableUnderline
              >
                {currencies.map((cur) => (
                  <MenuItem key={cur} value={cur}>
                    {cur}
                  </MenuItem>
                ))}
              </Select>
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
}
